(function () {
  const allowedPaths = [
    "/pages/subscription-box",
    "/products/"
  ];

  const currentPath = window.location.pathname;

  const shouldRun = allowedPaths.some(path =>
    currentPath === path || currentPath.startsWith(path)
  );

  if (!shouldRun) {
    console.log("⚡Lightning Script ❌ not loaded");
    return; // stop execution
  }

  console.log("⚡Lightning Script loaded on allowed page");

})();


// ---------------------------------------------------------
// 1. GLOBAL STATE & CONFIGURATION
// ---------------------------------------------------------
window.cartSyncQueue = {};         // Pending updates { variantId: quantity }
window.globalSyncTimer = null;     // Debounce timer
window.isSyncing = false;          // Network lock flag
window.initialOtherItemsCount = 0; // Tracks non-subscription items
window.selectedProducts = [];      // Local source of truth
window.cachedCart = null;          // Local Cart Cache

const DYNAMIC_BOX_ID = "981306cb-35f3-43f5-9e86-c0a649d35c58";

window.sellingPlanConfig = {
  "2w": {
    member: 20075970647,   // 2 Week Member Price
    standard: 20076462167  // Every 2 Weeks
  },
  "4w": {
    member: 20076003415,   // 4 Week Member Price
    standard: 20076494935  // Every 4 Weeks
  },
  "one-time": {
    // combined: 20076527703  // One Time Only
  }
};

const formatCurrency = (amountInDollars) => {
  const cents = Math.round(amountInDollars * 100);  
  return window.Shopify.formatMoney(cents, window.Shopify.money_format);
};

// ---------------------------------------------------------
// 2. GLOBAL HELPER FUNCTIONS
// ---------------------------------------------------------

// Get current frequency
const getSelectedFrequency = () => 
  document.querySelector('input[name="frequency"]:checked')?.value || "one-time";

// Logic to pick the correct ID from the Config above
const getApplicablePlanId = (product, frequency) => {
  if (!product || !product.sellingPlans) return null;

  if (frequency === "one-time") {
    return null;
    // const targetId = window.sellingPlanConfig["one-time"].combined;
    // const hasPlan = product.sellingPlans.some(sp => Number(sp.id) === targetId);
    // return hasPlan ? targetId : null; 
  }

  const config = window.sellingPlanConfig[frequency];
  
  if (!config) return null;

  const isMember = window.Shopify && window.Shopify.customer_member_login === true;

  if (isMember) {
    // A. MEMBER: Get MEMBER ID
    const hasMemberPlan = product.sellingPlans.some(sp => Number(sp.id) === config.member);
    if (hasMemberPlan) return config.member;    
  }

  // B. IF NOT MEMBER: Get Standard ID
  const hasStandardPlan = product.sellingPlans.some(sp => Number(sp.id) === config.standard);
  if (hasStandardPlan) return config.standard;

  return null;
};

const handleMemberWidget = (arg) => {
  const frequency = (arg && arg.value) ? arg.value : arg;

  const isOneTime = frequency === 'one-time';

  document.querySelectorAll(".member-pricing-container").forEach(m => {
    m.classList.toggle("hidden", isOneTime);
  });

  document.querySelectorAll(".one_time_regular").forEach(el => {
    el.classList.toggle("hidden", !isOneTime);
  });
};

// Instant Cart Bubble Update (Local Math - No API Wait)
window.updateBubbleInstant = function() {
  const boxTotal = window.selectedProducts.reduce((sum, p) => sum + (p.quantity || 0), 0);
  const totalGlobal = boxTotal + (window.initialOtherItemsCount || 0);
  
  document.querySelectorAll("#cart-icon-bubble").forEach(container => {
    let bubble = container.querySelector(".cart-count-bubble");
    let span = bubble ? bubble.querySelector("span[aria-hidden='true']") : null;
    
    if (totalGlobal > 0) {
      if (!bubble) {
        container.insertAdjacentHTML('beforeend', 
          `<div class="cart-count-bubble">
             <span aria-hidden="true">${totalGlobal}</span>
             <span class="visually-hidden">${totalGlobal} items</span>
           </div>`
        );
      } else if (span) {
        span.textContent = totalGlobal;
        bubble.style.display = 'block';
      }
    } else {
      if (bubble) bubble.style.display = 'none';
    }
  });
};

// Global UI Lock
window.toggleGlobalLoadingState = function(isLoading) {
  const checkoutBtn = document.getElementById("progress-checkout-btn");
  if (checkoutBtn) {
    const textSpan = checkoutBtn.querySelector(".checkout-button-text");
    if (isLoading) {
      checkoutBtn.classList.add("loading", "disabled");
      checkoutBtn.setAttribute("disabled", "true");
      if (textSpan) {
         if(!checkoutBtn.dataset.originalText) checkoutBtn.dataset.originalText = textSpan.textContent;
         textSpan.textContent = "Updating...";
      }
    } else {
      checkoutBtn.classList.remove("loading", "disabled");
      checkoutBtn.removeAttribute("disabled"); 
      if (textSpan && checkoutBtn.dataset.originalText) textSpan.textContent = checkoutBtn.dataset.originalText;
      if (typeof updateProgressCheckoutButton === "function") updateProgressCheckoutButton(); 
    }
  }

  const freqLabels = document.querySelectorAll(".sub-button, .one-time-box");
  const qtyInputs = document.querySelectorAll(".quantity-input, .qty-btn");

  if(isLoading) {
      freqLabels.forEach(el => { el.style.pointerEvents = "none"; el.style.opacity = "0.7"; });
      qtyInputs.forEach(el => { el.style.pointerEvents = "none"; el.style.opacity = "0.6"; });
  } else {
      freqLabels.forEach(el => { el.style.pointerEvents = "auto"; el.style.opacity = "1"; });
      qtyInputs.forEach(el => { el.style.pointerEvents = "auto"; el.style.opacity = "1"; });
  }
};

// ---------------------------------------------------------
// 3. OPTIMIZED DATA FETCHING (Caching)
// ---------------------------------------------------------
window.sellingPlanCache = window.sellingPlanCache || {};
window.sellingPlanPromises = window.sellingPlanPromises || {};

const fetchSellingPlans = async (productHandle) => {
  if (!productHandle) return [];
  
  // 1. Check Memory Cache (RAM) - always fresh for the current session
  if (window.sellingPlanCache[productHandle]) return window.sellingPlanCache[productHandle];
  
  // 2. Check Pending Requests (Prevent duplicate calls)
  if (window.sellingPlanPromises[productHandle]) return await window.sellingPlanPromises[productHandle];

  const fetchTask = async () => {
    try {
      const storageKey = `sp_cache_v5_${productHandle}`;
      const CACHE_DURATION = 30 * 60 * 1000; // 30 minutes in milliseconds
      
      const cachedRaw = localStorage.getItem(storageKey);
      if (cachedRaw) {
        try {
          const parsed = JSON.parse(cachedRaw);
          const age = Date.now() - (parsed.timestamp || 0);

          if (parsed.data && age < CACHE_DURATION) {
            // console.log(`⚡ Loaded ${productHandle} from Local Storage (Age: ${Math.round(age/1000/60)} mins)`);
            window.sellingPlanCache[productHandle] = parsed.data;
            return parsed.data;
          } else {
            // console.log(`⌛ Cache expired for ${productHandle}. Fetching fresh data...`);
            localStorage.removeItem(storageKey);
          }
        } catch (e) {
          localStorage.removeItem(storageKey);
        }
      }
      // --- END CACHE CHECK ---

      // FETCH FRESH DATA
      const data = await fetch(`/products/${productHandle}.js?fields=selling_plan_groups,id,handle,variants`)
        .then((r) => { if (!r.ok) throw new Error("Product not found"); return r.json(); });

      const plans = [];
      if (data.selling_plan_groups) {
        data.selling_plan_groups.forEach((group) => {
          group.selling_plans.forEach((plan) => {
            plans.push({
              id: plan.id,
              name: plan.name,
              interval: plan.options,
              priceAdjustments: plan.price_adjustments,
              group_name: group.name 
            });
          });
        });
      }

      const variantMap = {};
      if(data.variants) {
          data.variants.forEach(v => { variantMap[v.id] = v.price / 100; }); 
      }

      const result = { plans, variantMap }; 

      window.sellingPlanCache[productHandle] = result;
      
      try { 
        localStorage.setItem(storageKey, JSON.stringify({
          data: result,
          timestamp: Date.now() // <--- Save current time
        })); 
      } catch (e) {}

      return result;
    } catch (err) {
      console.error("❌ Error fetching plans:", err);
      return { plans: [], variantMap: {} };
    }
  };

  window.sellingPlanPromises[productHandle] = fetchTask();
  return await window.sellingPlanPromises[productHandle];
};

async function ensureSellingPlans(product) {
  if ((!product.sellingPlans || !Array.isArray(product.sellingPlans) || product.sellingPlans.length === 0) && product.handle) {
    try { 
        const data = await fetchSellingPlans(product.handle);
        if (data && data.plans) {
            product.sellingPlans = data.plans;
        } else {
            product.sellingPlans = [];
        }
    } catch (e) { 
        product.sellingPlans = []; 
    }
  }
  return product;
}

// Image slider functionality (Fixed)
function initImageSliders() {
  document.querySelectorAll(".thumbs-slider .thumb-slide").forEach((thumb) => {
    const newThumb = thumb.cloneNode(true);
    thumb.parentNode.replaceChild(newThumb, thumb);
    
    newThumb.addEventListener("click", function (e) {
      e.stopPropagation(); 
      const mainImageContainer = this.closest(".product-images").querySelector(".main-image-slider");
      const mainImage = mainImageContainer.querySelector(".main-image");
      const imgTag = this.querySelector("img");
      
      if(imgTag && mainImage) {
          const newImageSrc = imgTag.getAttribute("data-main-image");
          mainImage.src = newImageSrc;
      }
      this.closest(".thumbs-slider").querySelectorAll(".thumb-slide").forEach((t) => t.classList.remove("active"));
      this.classList.add("active");
    });
  });
}

// Metafield accordion functionality (Fixed)
function initMetafieldAccordions() {
  document.querySelectorAll(".metafield-accordion-header").forEach((header) => {
    const newHeader = header.cloneNode(true);
    header.parentNode.replaceChild(newHeader, header);

    newHeader.addEventListener("click", function (e) {
      e.stopPropagation();
      const accordion = this.closest(".metafield-accordion");
      const isActive = accordion.classList.contains("active");
      const parentBody = accordion.closest(".accordion-body");
      if(parentBody) {
          parentBody.querySelectorAll(".metafield-accordion").forEach((acc) => acc.classList.remove("active"));
      }
      if (!isActive) accordion.classList.add("active");
    });
  });
}

// Mobile add button functionality
function initMobileAddButtons() {
  document.querySelectorAll(".add-btn-mobile").forEach((button) => {
    button.addEventListener("click", function () {
      const accordion = this.closest(".accordion");
      const quantityInput = accordion.querySelector(".quantity-input");
      const plusBtn = accordion.querySelector(".qty-btn.plus");
      if (quantityInput) quantityInput.value = 1;
      if (plusBtn) plusBtn.click();
      this.textContent = "Added!";
      setTimeout(() => { this.textContent = "Add"; }, 1000);
    });
  });
}

function initShowPricesInfo() {
  const infoIcon = document.querySelector(".info-icon");
  const infoPopup = document.querySelector("#lock-price-popup .info-popup");
  const overlay = document.querySelector("#lock-price-popup");
  const closeBtn = document.querySelector("#lock-price-popup .info-popup-close");
  if(infoIcon && infoPopup) {
      infoIcon.addEventListener("click", () => { infoPopup.classList.add("active"); overlay.classList.add("active"); });
      overlay.addEventListener("click", () => { infoPopup.classList.remove("active"); overlay.classList.remove("active"); });
      closeBtn.addEventListener("click", () => { infoPopup.classList.remove("active"); overlay.classList.remove("active"); });
      infoPopup.addEventListener("click", (e) => e.stopPropagation());
  }
}

// ==========================
// 📱 MOBILE LAYOUT ADJUSTMENTS
// ==========================
function adjustMobileLayout() {
  const messageBox = document.getElementById("product_progress_message");
  const checkoutWrapper = document.querySelector(".progress-checkout-wrapper");
  const mobileTarget = document.querySelector(".subscription-container"); // The reference element
  
  // Original Parents (for Desktop revert)
  const desktopMsgParent = document.querySelector(".subscription-options");
  const desktopBtnParent = document.querySelector(".one-time-subscription-wrapper");

  if (!messageBox || !checkoutWrapper || !mobileTarget || !desktopMsgParent || !desktopBtnParent) return;

  const isMobile = window.innerWidth <= 821;

  if (isMobile) {
    // 📱 MOBILE: Move elements OUTSIDE and BELOW the container
    
    // 1. Move Message Box (Immediately after container)
    // We check to avoid constant re-insertion
    if (mobileTarget.nextElementSibling !== messageBox) {
       mobileTarget.insertAdjacentElement("afterend", messageBox);
       messageBox.classList.add("mobile-moved");
    }

    // 2. Move Checkout Button (Immediately after Message Box)
    // This ensures the order: Container -> Message -> Button
    if (messageBox.nextElementSibling !== checkoutWrapper) {
       messageBox.insertAdjacentElement("afterend", checkoutWrapper);
       checkoutWrapper.classList.add("mobile-moved");
    }

  } else {
    // 💻 DESKTOP: Move elements back INSIDE their original parents
    
    // 1. Revert Message Box to subscription-options
    if (!desktopMsgParent.contains(messageBox)) {
      desktopMsgParent.appendChild(messageBox);
      messageBox.classList.remove("mobile-moved");
    }

    // 2. Revert Checkout Button to one-time-subscription-wrapper
    if (!desktopBtnParent.contains(checkoutWrapper)) {
      desktopBtnParent.appendChild(checkoutWrapper);
      checkoutWrapper.classList.remove("mobile-moved");
    }
  }
}

// ---------------------------------------------------------
// 4. BATCH PROCESSOR (The Engine)
// ---------------------------------------------------------
window.processCartQueue = async function() {
  if (Object.keys(window.cartSyncQueue).length === 0) {
    window.isSyncing = false;
    toggleGlobalLoadingState(false);
    return;
  }
  
  window.isSyncing = true;
  toggleGlobalLoadingState(true);

  // Snapshot Queue
  const queueSnapshot = { ...window.cartSyncQueue };
  window.cartSyncQueue = {}; 

  console.log("⚡ Processing Batch:", Object.keys(queueSnapshot).length, "items");

  try {
    const currentFrequency = getSelectedFrequency();

    // 1. GET CART (Use Cache if available)
    if (!window.cachedCart) {
        window.cachedCart = await fetch("/cart.js", { credentials: "same-origin" }).then(r => r.json());
    }
    const cart = window.cachedCart;

    const batchUpdates = {}; 
    const batchAdds = [];    
    
    // Optional Discount Tagging
    const currentDiscountPercent = typeof calculateBuildBoxDiscount === 'function' ? calculateBuildBoxDiscount(window.selectedProducts) : 0;
    const discountTag = currentDiscountPercent > 0 ? `Dynamic Build a Box Discount (-${currentDiscountPercent}%)` : null;

    // 2. SORT ACTIONS
    const processingPromises = Object.entries(queueSnapshot).map(async ([id, qty]) => {
      const variantId = Number(id);
      const quantity = Number(qty);

      const existingItem = cart.items.find(item => 
        Number(item.variant_id) === variantId &&
        item.properties?._dynamicBoxId === DYNAMIC_BOX_ID
      );

      if (existingItem) {
        batchUpdates[existingItem.key] = quantity;
      } else if (quantity > 0) {
        let planToUse = undefined;
        const productData = window.selectedProducts.find(p => p.id === variantId);
        
        // ✅ FIX: Use dynamic helper instead of broken map
        if (productData) {
           await ensureSellingPlans(productData); 
           planToUse = getApplicablePlanId(productData, currentFrequency);
        }

        const properties = {
            _dynamicBoxId: DYNAMIC_BOX_ID,
            _frequency: currentFrequency
            // _subscriptionProduct: "true",
        };

        // Only add subscription tag if it's NOT one-time
        if (currentFrequency !== "one-time") {
            properties._subscriptionProduct = "true";
        }

        if(discountTag) properties["_discountInfo"] = discountTag;

        batchAdds.push({
          id: variantId,
          quantity: quantity,
          selling_plan: planToUse, // Correctly applies Member, Standard, or One-Time ID
          properties: properties
        });
      }
    });

    await Promise.all(processingPromises);

    // 3. EXECUTE API CALLS
    let finalCartData = null;

    // A. Updates/Removals
    if (Object.keys(batchUpdates).length > 0) {
      const res = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates: batchUpdates }),
        credentials: "same-origin"
      });
      finalCartData = await res.json();
      window.cachedCart = finalCartData; // Update Cache
    }

    // B. Adds
    if (batchAdds.length > 0) {
      const addRes = await fetch("/cart/add.js?sections=cart-icon-bubble", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: batchAdds }),
        credentials: "same-origin"
      });
      
      const addData = await addRes.json();
      if (addData.sections?.["cart-icon-bubble"]) {
         const b = document.getElementById("cart-icon-bubble");
         if(b) b.innerHTML = addData.sections["cart-icon-bubble"];
      }
      
      // Re-hydrate cache after add
      finalCartData = await fetch("/cart.js", { credentials: "same-origin" }).then(r => r.json());
      window.cachedCart = finalCartData; 
    }

    // 4. FINISH
    if (Object.keys(window.cartSyncQueue).length > 0) {
       processCartQueue(); // Recurse
    } else {
       if (finalCartData) triggerShopifyCartUpdate(finalCartData);
       else triggerShopifyCartUpdate(window.cachedCart);
       
       window.isSyncing = false;
       toggleGlobalLoadingState(false);
    }

  } catch (err) {
    console.error("❌ Batch Error:", err);
    window.cachedCart = null; // Clear cache on error
    window.isSyncing = false;
    toggleGlobalLoadingState(false);
  }
};

// ---------------------------------------------------------
// 5. MAIN LOGIC (DOM READY)
// ---------------------------------------------------------
document.addEventListener("DOMContentLoaded", function () {
  
  // A. PRE-LOAD (Optimistic)
  const fastSavedData = loadCartFromStorage(); // Uses new expiry logic
  if (fastSavedData) {
      try {
          const totalQty = fastSavedData.reduce((sum, item) => sum + (item.quantity || 0), 0);
          if(totalQty > 0) {
              document.querySelectorAll(".cart-count-bubble").forEach(b => {
                  let span = b.querySelector("span[aria-hidden='true']");
                  if(!span) b.innerHTML = `<span aria-hidden="true">${totalQty}</span><span class="visually-hidden">items</span>`;
                  else span.textContent = totalQty;
                  b.style.display = 'block';
              });
          }
      } catch(e) {}
  }


  const activeInput = document.querySelector('input[name="frequency"]:checked');
  const currentSelectedFrequency = activeInput ? activeInput.value : '2w';

  // // 2. Init
  // if (typeof updateMemberPriceVisibility === 'function') {
  //   updateMemberPriceVisibility(currentSelectedFrequency);
  // }

  if (typeof handleMemberWidget === 'function') {
    handleMemberWidget(currentSelectedFrequency);
  }

  // ---------------------------------------------------------
  // B. QUANTITY HANDLERS & STOCK LOGIC (TOAST ONLY)
  // ---------------------------------------------------------
  
  // Helper: Show Toast Message
  const showToast = (message, type = "normal") => {
    const toast = document.getElementById("toast-notification");
    if(!toast) return;
    
    toast.textContent = message;
    toast.className = "toast-notification show " + type; 
    
    if(window.toastTimer) clearTimeout(window.toastTimer);
    window.toastTimer = setTimeout(() => { 
      toast.className = toast.className.replace("show", ""); 
    }, 3000);
  };

  // 1. Helper to toggle arrow visibility
  const updateArrowVisibility = (container) => {
    if (!container) return;
    
    if (container.clientWidth === 0) return;

    const wrapper = container.closest('tolstoy-stories') || container.closest('._storiesVideoContainer_1v61q_12');
    if (!wrapper) return;

    const prevBtn = wrapper.querySelector('.tolstoy-stories-previous-button');
    const nextBtn = wrapper.querySelector('.tolstoy-stories-next-button');
    
    const isScrollable = container.scrollWidth > (container.clientWidth + 10);

    if (!isScrollable) {
        if (prevBtn) prevBtn.setAttribute('data-visibility', 'hidden');
        if (nextBtn) nextBtn.setAttribute('data-visibility', 'hidden');
        return; 
    }

    const isAtStart = container.scrollLeft <= 10;
    const isAtEnd = (container.scrollLeft + container.clientWidth) >= (container.scrollWidth - 10);

    if (prevBtn) {
        if (isAtStart) prevBtn.setAttribute('data-visibility', 'hidden');
        else prevBtn.removeAttribute('data-visibility');
    }

    if (nextBtn) {
        if (isAtEnd) nextBtn.setAttribute('data-visibility', 'hidden');
        else nextBtn.removeAttribute('data-visibility');
    }
  };

  // 2. Click Listener for Buttons
  document.addEventListener('click', function(e) {
      const btn = e.target.closest('.tolstoy-stories-next-button, .tolstoy-stories-previous-button');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      const wrapper = btn.closest('tolstoy-stories') || btn.closest('._storiesVideoContainer_1v61q_12');
      const container = wrapper?.querySelector('.tolstoy-stories-tiles-container') || wrapper?.querySelector('._tilesContainer_1v61q_19');

      if (container) {
          const scrollAmount = 160; 
          const isNext = btn.classList.contains('tolstoy-stories-next-button') || btn.classList.contains('_nextArrowButtonContainer_1v61q_211');
          
          container.scrollBy({ left: isNext ? scrollAmount : -scrollAmount, behavior: 'smooth' });
          
          setTimeout(() => updateArrowVisibility(container), 350);
      }
  });

  // 2. This watches for the accordion to finish opening
  const resizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
      updateArrowVisibility(entry.target);
    }
  });

  // 3. Attach Listeners (Updated)
  const attachScrollListeners = () => {
    document.querySelectorAll('.tolstoy-stories-tiles-container, ._tilesContainer_1v61q_19').forEach(container => {
        resizeObserver.observe(container);

        if(!container.dataset.hasScrollListener) {
            container.addEventListener('scroll', () => updateArrowVisibility(container));
            container.dataset.hasScrollListener = "true";
        }
        
        updateArrowVisibility(container);
    });
  };

  // --- 1. ACCORDION TOGGLE LOGIC ---
  document.querySelectorAll(".subscription-main-box .accordion").forEach((acc) => {
    const body = acc.querySelector(".accordion-body");
    
    const toggle = (e) => {
      if (e.target.closest('.quantity-wrapper') || e.target.closest('.product-images') || e.target.closest('.metafield-accordion')) return;

      acc.classList.toggle("active");

      if (body) body.classList.toggle("active");

      if (body && body.classList.contains("active")) {
        try {
          const story = body.querySelector("tolstoy-stories");
           if (story && story.innerHTML.trim().length === 0) {
              const clone = story.cloneNode(true);
              story.parentNode.replaceChild(clone, story);
          } else if (story) {
              story.dispatchEvent(new Event("tolstoy:mount", { bubbles: true }));
          }
        } catch (e) { console.log("Tolstoy error:", e); }

        setTimeout(() => {
          const container = body.querySelector('.tolstoy-stories-tiles-container, ._tilesContainer_1v61q_19');
          if(container) updateArrowVisibility(container);
          
          if(typeof attachScrollListeners === 'function') attachScrollListeners(); 
        }, 500);          
        
        setTimeout(() => {
          window.dispatchEvent(new Event('resize'));
        }, 550);
      }
    };

    const title = acc.querySelector(".accordion-title");
    const iconPlus = acc.querySelector(".plus-icon");
    const iconMinus = acc.querySelector(".minus-icon");
    const headerDiv = acc.querySelector(".accordion-header"); 
    
    if(title) title.addEventListener("click", toggle);
    if(iconPlus) iconPlus.addEventListener("click", toggle);
    if(iconMinus) iconMinus.addEventListener("click", toggle);
    if(headerDiv) headerDiv.addEventListener("click", (e) => { if(e.target === headerDiv || e.target.classList.contains("accordion-title-wrapper")) toggle(e); });

    // --- 2. QUANTITY & INVENTORY LOGIC ---
    const input = acc.querySelector(".quantity-input");
    const minus = acc.querySelector(".qty-btn.minus");
    const plus = acc.querySelector(".qty-btn.plus");
    const box = acc.querySelector(".product-box");
    
    if (!input || !box) return;

    const id = Number(box.dataset.productId);
    const titleText = box.dataset.productTitle;
    const price = parseFloat(box.dataset.productPrice);
    const image = box.dataset.productImage;
    const handle = box.dataset.productHandle;

    // 📦 READ INVENTORY
    const invManagement = box.dataset.inventoryManagement;
    const invPolicy = box.dataset.inventoryPolicy;
    const invQuantity = parseInt(box.dataset.inventoryQuantity) || 0;
    
    const maxAvailable = (invManagement === 'shopify' && invPolicy === 'deny') ? invQuantity : Infinity;

    // Initialize visual value based on actual saved data
    const savedItem = window.selectedProducts.find(p => p.id === id);
    input.value = savedItem ? savedItem.quantity : 0; 

    const updateQty = async (deltaOrVal, direct = false) => {
      if (window.isSyncing) return; 

      // 1. Get current DOM value
      let domVal = parseInt(input.value) || 0;
      
      // 2. Calculate Target Value
      let newVal = direct ? deltaOrVal : domVal + deltaOrVal;
      
      // 3. Get Current SAVED Quantity (The "Real" Quantity in Cart)
      const existingProduct = window.selectedProducts.find(p => p.id === id);
      const currentSavedQty = existingProduct ? existingProduct.quantity : 0;

      // 4. Validate Min/Max
      if (newVal < 0) newVal = 0;

      // Stock Check (Only if increasing)
      if (newVal > currentSavedQty && maxAvailable !== Infinity) {
         if (newVal > maxAvailable) {
            newVal = maxAvailable; 
            showToast(`Only ${maxAvailable} available in stock!`, "warning");
         }
      }

      if (newVal === currentSavedQty) {
          if (direct && domVal !== currentSavedQty) input.value = currentSavedQty;
          return; 
      }

      // Update Input Visual
      input.value = newVal; 
      
      let existing = window.selectedProducts.find((p) => p.id === id);
      const currentFrequency = getSelectedFrequency();
      
      // Determine Plan ID
      let currentPlanId = null;
      try {
         const planData = await fetchSellingPlans(handle);
         const mockProduct = { id, sellingPlans: planData.plans || [] };
         currentPlanId = getApplicablePlanId(mockProduct, currentFrequency);
      } catch(e) { console.error("Plan Error", e); }

      if (!existing && newVal > 0) {
        existing = { id, title: titleText, price, image, handle, quantity: newVal, _dynamicBoxId: DYNAMIC_BOX_ID, frequency: currentFrequency, sellingPlanId: currentPlanId, sellingPlans: [] };
        window.selectedProducts.push(existing);
        if(typeof addToCartUI === 'function') addToCartUI(existing); 
        ensureSellingPlans(existing).then(() => {
             if(typeof updateTotals === 'function') updateTotals();
             if(typeof updateCartSummary === 'function') updateCartSummary();
        });
      } else if (existing) {
        existing.quantity = newVal;
        existing.frequency = currentFrequency;
        existing.sellingPlanId = currentPlanId; 
        if (newVal === 0) {
          if(typeof removeFromCartUI === 'function') removeFromCartUI(id);
          window.selectedProducts = window.selectedProducts.filter((p) => p.id !== id);
        } else {
          if(typeof updateCartUI === 'function') updateCartUI(existing);
        }
      }

      saveCartToStorage();
      if(typeof updateTotals === 'function') updateTotals();
      if(typeof updateCartSummary === 'function') updateCartSummary();
      updateBubbleInstant();

      window.cartSyncQueue[id] = newVal;
      const coBtn = document.getElementById("progress-checkout-btn");
      if(coBtn && !coBtn.classList.contains('loading')) {
          const txt = coBtn.querySelector(".checkout-button-text");
          if(txt) { coBtn.dataset.originalText = txt.textContent; txt.textContent = "Updating..."; coBtn.classList.add("disabled"); }
      }

      if (window.globalSyncTimer) clearTimeout(window.globalSyncTimer);
      window.globalSyncTimer = setTimeout(() => {
        if (!window.isSyncing) processCartQueue();
      }, 300); 
    };

    acc.updateQuantity = updateQty;
    if(minus) minus.addEventListener("click", (e) => { e.stopPropagation(); updateQty(-1); });
    if(plus) plus.addEventListener("click", (e) => { e.stopPropagation(); updateQty(1); });
    
    if(input) input.addEventListener("change", (e) => { 
        e.stopPropagation(); 
        updateQty(parseInt(input.value) || 0, true); 
    });
    
    if(input) input.addEventListener("click", (e) => e.stopPropagation());
  });

  // C. FREQUENCY SWITCHER (Sync)
  document.querySelectorAll('input[name="frequency"]').forEach((f) => {
    f.addEventListener("change", async () => {
      const newFrequency = f.value;
      console.log("⚡ Frequency:", newFrequency);

      saveFrequencyToStorage(newFrequency);
      if(typeof updateFrequencyButtonState === 'function') updateFrequencyButtonState(newFrequency);
      
      // Update local state visuals immediately
      window.selectedProducts.forEach(p => p.frequency = newFrequency);
      
      if(typeof updateTotals === 'function') updateTotals();
      if(typeof updateCartSummary === 'function') updateCartSummary(); 

      if (window.selectedProducts.length === 0) return;

      toggleGlobalLoadingState(true);

      try {
        // We do not rely on window.cachedCart here to ensure keys are 100% accurate
        const freshCart = await fetch("/cart.js", { credentials: "same-origin" }).then(r => r.json());
        window.cachedCart = freshCart; // Update global cache

        // Parallel Plan Fetch (Ensure data exists)
        await Promise.all(window.selectedProducts.map(p => ensureSellingPlans(p)));

        const updates = {};
        let hasRemovals = false;
        
        // 2. Identify items to remove (Any item belonging to this box)
        freshCart.items.forEach(item => {
          if (item.properties?._dynamicBoxId === DYNAMIC_BOX_ID) {
            updates[item.key] = 0;
            hasRemovals = true;
          }
        });

        // 3. Prepare items to ADD with NEW frequency
        const itemsToAdd = window.selectedProducts
          .filter(p => p.quantity > 0)
          .map(p => {
             // Calculate correct Plan ID (Member vs Standard vs One-Time)
             const targetPlanId = getApplicablePlanId(p, newFrequency);

             return {
               id: p.id,
               quantity: p.quantity,
               selling_plan: targetPlanId, // Will be ID or null
               properties: {
                 _dynamicBoxId: DYNAMIC_BOX_ID,
                 _subscriptionProduct: "true",
                 _frequency: newFrequency
               }
             };
          });

        // 4. EXECUTE REMOVAL (With 422 Safety Catch)
        if (hasRemovals) {
           try {
             const updateRes = await fetch("/cart/update.js", {
               method: "POST",
               headers: { "Content-Type": "application/json" },
               body: JSON.stringify({ updates }),
               credentials: "same-origin"
             });
             
             // If 422, it usually means items are already gone. We ignore it to let the Add happen.
             if (!updateRes.ok && updateRes.status !== 422) {
                throw new Error("Cart Update Failed");
             }
           } catch (removeErr) {
             console.warn("⚠️ Removal warning (ignoring to proceed with add):", removeErr);
           }
        }

        // 5. EXECUTE ADD (Always runs now)
        if (itemsToAdd.length > 0) {
          // Small delay to ensure Shopify processed the removal state internally
          await new Promise(r => setTimeout(r, 250));

          await fetch("/cart/add.js", {
             method: "POST",
             headers: { "Content-Type": "application/json" },
             body: JSON.stringify({ items: itemsToAdd }),
             credentials: "same-origin"
           });
        }

        // 6. Final Refresh
        const finalCart = await fetch("/cart.js", { credentials: "same-origin" }).then(r => r.json());
        window.cachedCart = finalCart; 
        if (typeof triggerShopifyCartUpdate === "function") triggerShopifyCartUpdate(finalCart);

      } catch (err) {
        console.error("❌ Freq Switcher Critical Error:", err);
      } finally {
        toggleGlobalLoadingState(false);
      }
    });
  });

  // D. INITIALIZATION
  if (window.location.pathname.includes("/pages/subscription-box")) {
    console.log("🚀 Init: Lightning Engine");

    (async () => {
      try {
        const cart = await fetch("/cart.js", { credentials: "same-origin" }).then(r => r.json());
        window.cachedCart = cart; // ⚡ FILL CACHE

        const cartItems = cart.items.filter(i => i.properties?._dynamicBoxId === DYNAMIC_BOX_ID);
        const totalItems = cart.item_count;
        const subItemsCount = cartItems.reduce((sum, item) => sum + item.quantity, 0);
        window.initialOtherItemsCount = totalItems - subItemsCount;

        if (cartItems.length > 0) {
          console.log("🟢 Loaded from Cart.");
          
          // 1. Map initial data (Contains Discounted Prices)
          selectedProducts = cartItems.map(item => ({
            id: item.variant_id,
            title: item.product_title || item.title,
            price: item.price / 100, // ⚠️ potentially discounted
            quantity: item.quantity,
            image: item.image,
            handle: item.handle,
            _dynamicBoxId: DYNAMIC_BOX_ID,
            frequency: item.properties?._frequency || "2w",
            sellingPlanId: item.selling_plan_allocation?.selling_plan?.id,
            sellingPlans: [] 
          }));

          const cartFreq = cartItems[0].properties?._frequency;
          if (cartFreq) {
            saveFrequencyToStorage(cartFreq);
            if(typeof updateFrequencyButtonState === 'function') updateFrequencyButtonState(cartFreq);
            const radio = document.querySelector(`input[name="frequency"][value="${cartFreq}"]`);
            if (radio) radio.checked = true;
          } 
          
          // 2. Fetch Data & CORRECT PRICES
          await Promise.all(selectedProducts.map(async (p) => {
             // Fetch plans + real prices
             const data = await fetchSellingPlans(p.handle);
             p.sellingPlans = data.plans || [];
             
             if(data.variantMap && data.variantMap[p.id]) {
                 const realPrice = data.variantMap[p.id];
                 if(realPrice > p.price) {
                     p.price = realPrice;
                 }
             }
             return p;
          }));
        } else {
          console.log("⚪ Cart empty.");
          selectedProducts = [];
          localStorage.removeItem("subscriptionCart");
        }

        // Update UI
        document.querySelectorAll(".quantity-input").forEach(el => el.value = 0);
        selectedProducts.forEach(p => {
          const input = document.querySelector(`.product-box[data-product-id="${p.id}"]`)
            ?.closest(".accordion")?.querySelector(".quantity-input");
          if (input) input.value = p.quantity;
          if(typeof addToCartUI === 'function') addToCartUI(p);
        });

        if(typeof updateTotals === 'function') updateTotals();
        if(typeof updateCartSummary === 'function') updateCartSummary();
        saveCartToStorage();
        updateBubbleInstant();

        // HIDE LOADER (Success)
        const loader = document.getElementById("subscription-loader");
        if(loader) {
          setTimeout(() => {
            loader.classList.remove("active");
            setTimeout(() => loader.style.display = 'none', 400); 
          }, 500); 
        }

      } 
      catch (err) { 
        console.error("Init Error:", err);
        // HIDE LOADER (Even on error, so page is usable)
        const loader = document.getElementById("subscription-loader");
        if(loader) loader.classList.remove("active");
      }
    })();
  }

  // E. Pre-fetch plans
  const products = document.querySelectorAll('.product-box[data-product-handle]');
  Array.from(products).forEach(box => { if(box.dataset.productHandle) fetchSellingPlans(box.dataset.productHandle); });
  
  // F. Helpers Init (Existing)
  if(typeof initImageSliders === 'function') initImageSliders();
  if(typeof initMetafieldAccordions === 'function') initMetafieldAccordions();
  if(typeof initMobileAddButtons === 'function') initMobileAddButtons();
  if(typeof initShowPricesInfo === 'function') initShowPricesInfo();
  
  // G. Tabs (Existing)
  const tabButtons = document.querySelectorAll(".subscription-main-box .tab-button");
  const tabContents = document.querySelectorAll(".subscription-main-box .tab-content");
  const isMobile = () => window.innerWidth <= 821;

  const initTabs = () => {
    if (isMobile()) {
      // 🔹 Move contents below buttons (accordion style)
      tabButtons.forEach((btn) => {
        const targetId = btn.dataset.tab;
        const content = document.getElementById(targetId);

        if (content && !btn.nextElementSibling?.classList.contains("tab-content")) {
          btn.insertAdjacentElement("afterend", content);
        }
      });
    }
  };

  tabButtons.forEach(btn => {
      btn.addEventListener("click", (e) => {
          e.preventDefault(); 
          e.stopPropagation();

          const targetId = btn.dataset.tab;
          const content = document.getElementById(targetId);
          if(!content) return;
          if(isMobile()) {
              if(btn.classList.contains("active")) { 
                btn.classList.remove("active");
                content.classList.remove("active"); 
              } else { 
                tabButtons.forEach(b => b.classList.remove("active"));
                tabContents.forEach(c => c.classList.remove("active"));
                btn.classList.add("active");
                content.classList.add("active"); 
              }
          } else {
              tabButtons.forEach(b => b.classList.remove("active"));
              tabContents.forEach(c => c.classList.remove("active"));
              btn.classList.add("active"); 
              content.classList.add("active");
          }
      });
  });


  initTabs();

  // ---------------------------------------------------------
  // H. CHECKOUT BUTTON CLICK LISTENERS
  // ---------------------------------------------------------
  
  // 1. Main Progress Checkout Button
  const progressCheckoutBtn = document.getElementById("progress-checkout-btn");
  if (progressCheckoutBtn) {
    progressCheckoutBtn.addEventListener("click", function (e) {
      e.preventDefault();
      
      // Double-check if it's disabled or currently syncing
      if (this.disabled || this.classList.contains("disabled")) return;

      // Visual Feedback
      const textSpan = this.querySelector(".checkout-button-text");
      if (textSpan) textSpan.textContent = "Redirecting...";
      this.classList.add("loading");

      // Go to Shopify Checkout
      window.location.href = "/checkout";
    });
  }

  // 2. Sidebar/Cart Box Checkout Button (if you use it)
  const cartCheckoutBtn = document.getElementById("cart-checkout");
  if (cartCheckoutBtn) {
    cartCheckoutBtn.addEventListener("click", function (e) {
      e.preventDefault();
      if (this.disabled || this.classList.contains("disabled")) return;
      
      this.textContent = "Redirecting...";
      window.location.href = "/checkout";
    });
  }

  // ---------------------------------------------------------
  // 📱 INIT MOBILE LAYOUT MOVES
  // ---------------------------------------------------------
  adjustMobileLayout();

  if (!window.__subscriptionTabsResizeAttached) {
    window.__subscriptionTabsResizeAttached = true;

    window.addEventListener("resize", () => {
      if (typeof updateTotals === "function") updateTotals();
      if (typeof initTabs === "function") initTabs();
      if (typeof adjustMobileLayout === "function") adjustMobileLayout();
    });
  }

  if ( window.innerWidth <= 821) {
    document.querySelector(".subscription-main-box .tab-button")?.classList.remove("active");
    document.querySelector(".subscription-main-box .tab-content")?.classList.remove("active");
  }
});

// ---------------------------------------------------------
// 6. UI HELPER FUNCTIONS (Totals, Drawer, etc.)
// ---------------------------------------------------------

function triggerShopifyCartUpdate(cartData = null) {
  if (window.PUB_SUB_EVENTS && window.publish) {
    window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: "subscription-box", cartData: cartData });
  }
  document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: cartData } }));
  document.dispatchEvent(new CustomEvent("cart:build", { detail: { cart: cartData } }));
  
  if (cartData && !cartData.sections) {
     refreshCartSections(); 
  } else if (cartData && cartData.sections) {
     updateCartSectionsFromData(cartData.sections);
  }
  updateCartCountBubble(cartData);
  if (typeof updateCheckoutButtons === "function") updateCheckoutButtons();
}

function updateCartSectionsFromData(sections) {
  if (!sections) return;
  if (sections["cart-drawer"]) {
    const cartDrawerElement = document.querySelector("cart-drawer");
    const cartDrawerContent = document.querySelector("#CartDrawer");
    if (cartDrawerContent) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(sections["cart-drawer"], "text/html");
      const newDrawerContent = doc.querySelector("#CartDrawer");
      if (newDrawerContent) {
        cartDrawerContent.innerHTML = newDrawerContent.innerHTML;
        if (cartDrawerElement) {
            if (newDrawerContent.querySelector(".cart-drawer__warnings")) {
                cartDrawerElement.classList.add("is-empty");
            } else {
                cartDrawerElement.classList.remove("is-empty");
            }
        }
      }
    }
  }
  if (sections["cart-icon-bubble"]) {
    const icon = document.getElementById("cart-icon-bubble");
    if (icon) {
        icon.innerHTML = sections["cart-icon-bubble"];
        const count = icon.querySelector(".cart-count-bubble span[aria-hidden='true']");
        if(count && parseInt(count.innerText) > 0) {
            const bubble = icon.querySelector(".cart-count-bubble");
            if(bubble) bubble.style.display = 'block';
        }
    }
  }
}

async function refreshCartSections() {
  try {
    const res = await fetch("/?sections=cart-icon-bubble,cart-drawer", { credentials: "same-origin" });
    if (res.ok) updateCartSectionsFromData(await res.json());
  } catch (e) {}
}

function updateCartCountBubble(cartData) {
  if (!cartData) return;
  const count = cartData.item_count || 0;
  const containers = document.querySelectorAll(".cart-count-bubble");
  if (containers.length === 0 && count > 0) {
     const icon = document.getElementById("cart-icon-bubble");
     if(icon) icon.innerHTML = `<div class="cart-count-bubble"><span aria-hidden="true">${count}</span><span class="visually-hidden">${count} items</span></div>`;
     return;
  }
  containers.forEach(b => {
    const span = b.querySelector("span[aria-hidden='true']");
    if (span) span.textContent = count;
    b.style.display = count > 0 ? 'block' : 'none';
  });
}

const roundHalfUp = (num, decimals = 2) => Math.round(num * Math.pow(10, decimals)) / Math.pow(10, decimals);

const getSubscriptionPrice = (product) => {
  const frequency = getSelectedFrequency();
  
  // ✅ 1. Get correct ID via Config
  const selectedPlanId = getApplicablePlanId(product, frequency);

  if (!selectedPlanId) return product.price;
  
  if (!product.sellingPlans || !Array.isArray(product.sellingPlans)) return product.price;

  const plan = product.sellingPlans.find((sp) => String(sp.id) === String(selectedPlanId));
  const adj = plan?.priceAdjustments?.[0];
  
  if (!adj) return product.price;

  let finalPrice = product.price;
  if (adj.value_type === "percentage") finalPrice = roundHalfUp(product.price * (1 - adj.value / 100), 2);
  else if (adj.value_type === "fixed_amount") finalPrice = roundHalfUp(Math.max(0, product.price - adj.value / 100), 2);

  return isNaN(finalPrice) || finalPrice <= 0 ? product.price : finalPrice;
};

const addToCartUI = (product) => {
  const container = document.querySelector(".cart-box-items");
  if (!container) return;
  const existing = container.querySelector(`.cart-item[data-product-id="${product.id}"]`);
  if (existing) return updateCartUI(product);

  const price = getSubscriptionPrice(product);
  
  const html = `
    <div class="cart-item" data-product-id="${product.id}">
      <div class="cart-item-header">
        <button class="cart-item-delete">✕</button>
        <span class="cart-item-quantity">${product.quantity}</span>
      </div>
      <img src="${product.image || ""}" alt="${product.title}" class="cart-item-image" />
      <div class="cart-item-details">
        <div class="cart-item-title">${product.title}</div>
        <div class="cart-item-price">
          ${price === product.price 
            ? `<span style="color:green;">${formatCurrency(price * product.quantity)}</span>` 
            : `<span style="text-decoration:line-through;color:#999;">${formatCurrency(product.price * product.quantity)}</span>&nbsp;<span style="color:green;">${formatCurrency(price * product.quantity)}</span>`}
        </div>
      </div>
    </div>`;
  
  container.insertAdjacentHTML("beforeend", html);
};

const updateCartUI = (product) => {
  const el = document.querySelector(`.cart-item[data-product-id="${product.id}"]`);
  if (!el) return;
  
  const price = getSubscriptionPrice(product);
  el.querySelector(".cart-item-quantity").textContent = product.quantity;

  el.querySelector(".cart-item-price").innerHTML = price === product.price 
    ? `<span style="color:green;">${formatCurrency(price * product.quantity)}</span>` 
    : `<span style="text-decoration:line-through;color:#999;">${formatCurrency(product.price * product.quantity)}</span>&nbsp;<span style="color:green;">${formatCurrency(price * product.quantity)}</span>`;
};

const removeFromCartUI = (id) => document.querySelector(`.cart-item[data-product-id="${id}"]`)?.remove();

const calculateBuildBoxDiscount = (products) => {
  // const subtotal = products.reduce((sum, p) => sum + roundHalfUp(getSubscriptionPrice(p) * (p.quantity || 1)), 0);
  // if (subtotal >= 200) return 10;
  // if (subtotal >= 150) return 8;
  // if (subtotal >= 125) return 5;
  return 0;
};

const updateProgressMessageUI = (finalTotal, minOrder, shippingGoal) => {
  const checkoutBtn = document.getElementById("progress-checkout-btn");       
  const subTextSpan = checkoutBtn ? checkoutBtn.querySelector(".checkout-sub-text") : null;
  const configScript = document.getElementById("progress-message-config");
  
  if (!subTextSpan || !checkoutBtn || !configScript) return;

  let config = {};
  try { config = JSON.parse(configScript.textContent); } catch(e) {}

  const txtBelow = config.msg_below_min || "Add <strong>[amount]</strong> to unlock";
  const txtGap = config.msg_gap_shipping || "Add <strong>[amount]</strong> for Free Shipping";
  const txtSuccess = config.msg_success || "Free Shipping Unlocked!";

  if (window.selectedProducts.length === 0) {
    subTextSpan.innerHTML = "Add Products Below To Start Your Order";
    checkoutBtn.classList.remove("success-state", "gap-state");
    return;
  }

  if (finalTotal < minOrder) {
    const remaining = minOrder - finalTotal;
    const msg = txtBelow.replace('[amount]', formatCurrency(remaining)); 
    
    subTextSpan.innerHTML = msg;
    checkoutBtn.classList.remove("success-state", "gap-state");
  } 
  else if (finalTotal < shippingGoal) {
    const remaining = shippingGoal - finalTotal;
    const msg = txtGap.replace('[amount]', formatCurrency(remaining)); 

    subTextSpan.innerHTML = msg;
    checkoutBtn.classList.remove("success-state");
    checkoutBtn.classList.add("gap-state"); 
  }
  else {
    subTextSpan.innerHTML = txtSuccess;
    checkoutBtn.classList.remove("gap-state");
    checkoutBtn.classList.add("success-state");
  }
};

const updateTotals = () => {
  let total = 0;        
  let subPlanTotal = 0; 

  window.selectedProducts.forEach((p) => {
    total += p.price * p.quantity;
    subPlanTotal += getSubscriptionPrice(p) * p.quantity;
  });

  const finalDiscounted = subPlanTotal; 

  const oneTimeTotalEl = document.querySelector(".one-time-total");
  const subscriptionTotalEl = document.querySelector(".subscription-price");
  const annualPriceEl = document.querySelector("#sub-annual-price");

  // One-time Price
  if (oneTimeTotalEl) oneTimeTotalEl.textContent = formatCurrency(total);
  
  const discountPercent = total > 0 ? Math.round(((total - finalDiscounted) / total) * 100) : 0;

  // Subscription Price Box
  if (subscriptionTotalEl) {
      const isMobile = window.innerWidth <= 821;

      // <span class="discount-percent-splited">(${discountPercent}% off)</span>
      if (discountPercent > 0) {
        if (isMobile) {
            subscriptionTotalEl.innerHTML = `
            <div class="price-split">
              <div class="price-left">
                <span class="discounted-price-splited">Discounted price</span>
              </div>
              <div class="price-right">
                <span class="new-price">${formatCurrency(finalDiscounted)}</span>
                <span class="old-price">${formatCurrency(total)}</span>
              </div>
            </div>`;
        } else {
            subscriptionTotalEl.innerHTML = `
            Discounted price<br />
            <span class="subscription-total">
              <span style="text-decoration:line-through;color:#999;">${formatCurrency(total)}</span>
              &nbsp;<strong style="color:green;">${formatCurrency(finalDiscounted)}</strong>
              </span>`;
            }
      } else {
        subscriptionTotalEl.innerHTML = `
        Undiscounted Price<br />
        <strong>${formatCurrency(finalDiscounted)}</strong>`;
      }
      // <span>(${discountPercent}% off)</span>
  }

  const freq = getSelectedFrequency();
  if (annualPriceEl) {
    if (!window.selectedProducts.length || freq === "one-time") {
      annualPriceEl.textContent = "Add Products Below To Start Your Order";
    } else {
      const weeks = freq === "2w" ? 2 : 4; 
      const deliveries = 52 / weeks;
      const annualSavings = (total - finalDiscounted) * deliveries; 
      
      annualPriceEl.innerHTML = `<span style="color:green;font-weight:bold;">${formatCurrency(annualSavings)}</span>`;
    }
  }
  
  if(typeof updateCheckoutButtonState === 'function') updateCheckoutButtonState();
};

const updateCartSummary = () => {
  const container = document.querySelector(".cart-box-items");
  const summary = document.querySelector(".cart-box-summary");
  if (!container || !summary) return;
  container.innerHTML = "";

  let subtotalAfterPlan = 0, subtotalOriginal = 0, itemCount = 0;
  const boxDiscount = calculateBuildBoxDiscount(selectedProducts);
  
  const totalSubPrice = selectedProducts.reduce((sum, p) => sum + getSubscriptionPrice(p) * p.quantity, 0);

  selectedProducts.forEach((p) => {
    const qty = p.quantity;
    const subPrice = getSubscriptionPrice(p);
    const total = subPrice * qty;
    const original = p.price * qty;
    
    // Calculate display logic
    const itemDiscount = totalSubPrice > 0 ? (total / totalSubPrice) * boxDiscount : 0;
    const finalPrice = total - itemDiscount;
    const discountPercent = original > 0 ? Math.round(((original - finalPrice) / original) * 100) : 0;
    
    // UPDATED CART ITEM HTML
    container.insertAdjacentHTML("beforeend", `
      <div class="cart-item" data-product-id="${p.id}">
        <div class="cart-item-header"><button class="cart-item-delete">✕</button><span class="cart-item-quantity">${qty}</span></div>
        <img src="${p.image}" alt="${p.title}" class="cart-item-image"/>
        <div class="cart-item-details">
          <div class="cart-item-title">${p.title}</div>
          <div class="cart-item-price">
             ${finalPrice === original 
                 ? formatCurrency(finalPrice) 
                 : `<span style="text-decoration:line-through;color:#999;">${formatCurrency(original)}</span>&nbsp;<span style="color:green;">${formatCurrency(finalPrice)}</span><span class="cart-item-discount">(${discountPercent}% off)</span>`}
          </div>
        </div>
      </div>`);
      
      subtotalAfterPlan += total;
      subtotalOriginal += original;
      itemCount += qty;
  });

  summary.style.display = itemCount > 0 ? "block" : "none";
  document.getElementById("cart-items-count").textContent = itemCount;
  
  const totalDiscount = subtotalOriginal - subtotalAfterPlan + boxDiscount;
  const discountEl = document.getElementById("cart-discount");
  const parent = discountEl?.closest(".cart-discount-wrapper");
  
  // UPDATED DISCOUNT & SUBTOTAL DISPLAY
  if (discountEl) {
    if (totalDiscount > 0) {
      discountEl.textContent = formatCurrency(totalDiscount);
      if (parent) parent.style.display = "";
    } else if (parent) parent.style.display = "none";
  }
  
  document.getElementById("cart-subtotal").textContent = formatCurrency(subtotalAfterPlan - boxDiscount);
  updateCheckoutButtonState();
};

// 2. Main Checkout Button State (Enable/Disable)
const updateCheckoutButtonState = () => {
  const checkoutBtn = document.getElementById("cart-checkout");
  const messageBox = document.getElementById("product_progress_message");
  if (!checkoutBtn || !messageBox) return;
  
  const minOrder = parseFloat(messageBox.dataset.minThreshold) || 125;

  const totalSubPrice = selectedProducts.reduce((sum, p) => sum + getSubscriptionPrice(p) * p.quantity, 0);
  const boxDiscount = calculateBuildBoxDiscount(selectedProducts);
  const finalTotal = totalSubPrice - boxDiscount;

  // Logic: Disable if below Min Order or Empty.
  if (finalTotal < minOrder || selectedProducts.length === 0) {
    checkoutBtn.disabled = true;
    checkoutBtn.classList.add("disabled");
    
    checkoutBtn.title = `Minimum order is ${formatCurrency(minOrder)}`;
    
  } else {
    checkoutBtn.disabled = false;
    checkoutBtn.classList.remove("disabled");
    checkoutBtn.title = "";
  }
  
  // Trigger the text update on the other button
  updateProgressCheckoutButton();
};

// 2. UPDATED: Updates Main Text & Enable/Disable State
const updateProgressCheckoutButton = () => {
  const progressCheckoutBtn = document.getElementById("progress-checkout-btn");
  const messageBox = document.getElementById("product_progress_message");
  if(!messageBox || !progressCheckoutBtn) return;

  // Get Thresholds
  const minOrder = parseFloat(messageBox.dataset.minThreshold) || 125;
  const shippingGoal = parseFloat(messageBox.dataset.shippingThreshold) || 200;

  const totalSubPrice = selectedProducts.reduce((sum, p) => sum + getSubscriptionPrice(p) * p.quantity, 0);
  const boxDiscount = calculateBuildBoxDiscount(selectedProducts);
  const finalTotal = Math.max(0, totalSubPrice - boxDiscount);

  // 1. Update Sub-Text
  updateProgressMessageUI(finalTotal, minOrder, shippingGoal);

  // 2. Update Main Button Text & State
  const mainText = progressCheckoutBtn.querySelector(".checkout-button-text");

  if (finalTotal >= minOrder && selectedProducts.length > 0) {
    // UNLOCKED STATE
    if (mainText) mainText.textContent = "Checkout Now"; // Short Main Text
    progressCheckoutBtn.disabled = false;
    progressCheckoutBtn.classList.remove("disabled");
    progressCheckoutBtn.removeAttribute("disabled");
  } else {
    // LOCKED STATE
    if (mainText) {
        if(selectedProducts.length === 0) mainText.textContent = " ";
        else mainText.textContent = "Order Minimum Not Met";
    }
    
    progressCheckoutBtn.disabled = true;
    progressCheckoutBtn.classList.add("disabled");
    progressCheckoutBtn.setAttribute("disabled", "true");
  }
};

// const updateMemberPriceVisibility = (frequency) => {
//   document.querySelectorAll('.member-price-2w, .member-price-4w, .member-price-1w').forEach(el => {
//     el.classList.add('hidden');
//   });

//   if (frequency === '2w') {
//     document.querySelectorAll('.member-price-2w').forEach(el => el.classList.remove('hidden'));
//   } else if (frequency === '4w') {
//     document.querySelectorAll('.member-price-4w').forEach(el => el.classList.remove('hidden'));
//   } else {
//     document.querySelectorAll('.member-price-1w').forEach(el => el.classList.remove('hidden'));
//   }
// };

const updateFrequencyButtonState = (frequency) => {
  document.querySelectorAll(".sub-button, .one-time-box").forEach((btn) => btn.classList.remove("active"));
  const selectedRadio = document.querySelector(`input[name="frequency"][value="${frequency}"]`);
  if (selectedRadio) selectedRadio.closest(".sub-button, .one-time-box")?.classList.add("active");

  // updateMemberPriceVisibility(frequency);
  handleMemberWidget(frequency);
};

// 7. GLOBAL LISTENERS
document.addEventListener("click", (e) => {
  // A. Overlay Close
  if (e.target && e.target.id === "CartDrawer-Overlay") {
    const drawer = document.querySelector("cart-drawer");
    if (drawer && typeof drawer.close === "function") drawer.close();
    else if (drawer) {
        drawer.classList.remove("active");
        const overlay = document.getElementById("CartDrawer-Overlay");
        if(overlay) overlay.style.display = 'none';
    }
  }

  // B. Global Remove Sync (Trash Icon)
  const removeBtn = e.target.closest("cart-remove-button button") || e.target.closest(".cart-item-delete");
  if (removeBtn) {
      let id = removeBtn.dataset.variantId;
      if (!id) {
        const row = removeBtn.closest(".cart-item");
        if (row) id = row.dataset.productId;
      }

      if (id) {
        const variantId = Number(id);
        
        // 1. Update Local State
        if (window.selectedProducts) {
            window.selectedProducts = window.selectedProducts.filter(p => p.id !== variantId);
            saveCartToStorage();
        }

        // 2. Sync Accordion UI (if present on page)
        const productBox = document.querySelector(`.product-box[data-product-id="${variantId}"]`);
        if (productBox) {
            const accordion = productBox.closest(".accordion");
            if (accordion) {
                const input = accordion.querySelector(".quantity-input");
                if (input) input.value = 0;
            }
        }

        // 3. Update Totals
        if(typeof updateTotals === 'function') updateTotals();
        if(typeof updateCartSummary === 'function') updateCartSummary();
        if(typeof updateBubbleInstant === 'function') updateBubbleInstant();
        
        // 4. Force Sync Queue to ensure backend matches
        if(e.target.closest(".cart-box-items")) {
             window.cartSyncQueue[variantId] = 0; 
             if (window.globalSyncTimer) clearTimeout(window.globalSyncTimer);
             window.globalSyncTimer = setTimeout(() => { if (!window.isSyncing) processCartQueue(); }, 300);
        }
      }
  }
});

// C. INPUT CHANGE LISTENER (Handles Plus/Minus & Manual Typing)
document.addEventListener("change", (e) => {
    // Detect changes on Cart Drawer Inputs
    if (e.target && e.target.matches("cart-drawer input.quantity__input")) {
        const input = e.target;
        const variantId = Number(input.dataset.quantityVariantId);
        
        // Read the ACTUAL value from the DOM (No manual math)
        const newQty = parseInt(input.value) || 0;

        if (variantId && window.selectedProducts) {
            const product = window.selectedProducts.find(p => p.id === variantId);
            
            if (product) {
                // Determine if this is a removal or update
                if (newQty === 0) {
                    // Remove
                    window.selectedProducts = window.selectedProducts.filter(p => p.id !== variantId);
                    
                    // Sync Accordion to 0
                    const productBox = document.querySelector(`.product-box[data-product-id="${variantId}"]`);
                    if (productBox) {
                        const accordion = productBox.closest(".accordion");
                        if (accordion) accordion.querySelector(".quantity-input").value = 0;
                    }
                } else {
                    // Update
                    product.quantity = newQty;
                    
                    // Sync Accordion to match Drawer
                    const productBox = document.querySelector(`.product-box[data-product-id="${variantId}"]`);
                    if (productBox) {
                        const accordion = productBox.closest(".accordion");
                        if (accordion) accordion.querySelector(".quantity-input").value = newQty;
                    }
                }
                
                // Save & Refresh UI
                saveCartToStorage();
                if(typeof updateTotals === 'function') updateTotals();
                if(typeof updateCartSummary === 'function') updateCartSummary();
                if(typeof updateBubbleInstant === 'function') updateBubbleInstant();
            }
        }
    }
});

// ==========================
// 8. STORAGE MANAGEMENT (Auto-Clear after 60 mins)
// ==========================
const STORAGE_TTL = 30 * 60 * 1000; // 30 minutes in milliseconds

const saveCartToStorage = () => {
  const data = {
    cart: selectedProducts,
    timestamp: Date.now()
  };
  localStorage.setItem("subscriptionCartData", JSON.stringify(data));
};

const loadCartFromStorage = () => {
  const raw = localStorage.getItem("subscriptionCartData");
  if (!raw) return null;
  
  try {
    const data = JSON.parse(raw);
    const age = Date.now() - (data.timestamp || 0);
    
    // If older than 60 mins, clear and return null
    if (age > STORAGE_TTL) {
      console.log("⏳ Storage expired. Clearing cache.");
      localStorage.removeItem("subscriptionCartData");
      return null;
    }
    return data.cart;
  } catch (e) {
    return null;
  }
};

const saveFrequencyToStorage = (frequency) => localStorage.setItem("subscriptionFrequency", frequency);



